"use client";
import { jsxs as t, jsx as e } from "react/jsx-runtime";
const h = ({
  title: l,
  titleId: r,
  desc: i,
  descId: a,
  ...s
}) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 512 512",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": r,
    "aria-describedby": a,
    ...s,
    children: [
      i ? /* @__PURE__ */ e("desc", { id: a, children: i }) : null,
      l ? /* @__PURE__ */ e("title", { id: r, children: l }) : null,
      /* @__PURE__ */ e("path", { d: "m231.261 502 163.023-289.709H254.595L280.739 10 117.716 299.709h139.689z" })
    ]
  }
);
export {
  h as default
};
